module.exports = __webpack_public_path__ + "static/media/Car_Historico.83203947.svg";